import React, { memo } from "react";
import { Icon, ospThemes } from "@ospweb/sdk-ui";
import { cn } from "utils";
import {
  getCompleteFeatures,
  getFreeFeatures,
} from "../../shared/edCompleteFeatures";
import Translations from "@translate/components/Member/Subscription/SubscriptionCard/FeatureStatic";
import { I18nUtil } from "@utils/i18n";
import { BillingCycleType } from "../types";

const I18n = I18nUtil.createScoped(Translations);

interface FeatureStaticProps {
  className?: string;
  isFree: boolean;
  isRecommended: boolean;
  billingCycle?: BillingCycleType;
}

const FeatureStatic: React.FC<FeatureStaticProps> = ({
  className,
  isFree,
  billingCycle,
}) => {
  const features = isFree
    ? getFreeFeatures()
    : getCompleteFeatures(billingCycle);

  return (
    <div className={cn("flex flex-col gap-6", className)}>
      <div className="flex flex-col gap-4">
        <h3
          aria-label="Feature Static h3"
          data-openreplay-label="member_featurestatic_h3"
          id="sem-feature-static-h3"
          className="text-content_primary title_l"
        >
          {I18n.t("What you get:")}
        </h3>
        <div className="flex flex-col gap-4">
          {features.map((feature) => (
            <div key={feature} className="flex w-full gap-2 items-center">
              <div className="rounded-full size-4 flex items-center justify-center shrink-0 mt-0.5">
                <Icon
                  name="check"
                  size={16}
                  color={ospThemes.colors.content_brand_primary}
                />
              </div>
              <span className="body_medium_m text-content_secondary">
                {feature}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default memo(FeatureStatic);
